<template>
  <el-tooltip v-model="isOpen" :content="content" placement="top" effect="dark" manual popper-class="metric-info-tooltip">
    <i
      class="el-icon-info metric-info-tooltip__icon"
      :aria-label="content"
      role="button"
      tabindex="0"
      @pointerenter="openForMouse"
      @pointerleave="closeForMouse"
      @focus="open"
      @blur="close"
      @click.stop.prevent="toggle"
    ></i>
  </el-tooltip>
</template>
<script>
const MOUSE_POINTER = "mouse";

export default {
  props: {
    content: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isOpen: false
  }),
  mounted() {
    document.addEventListener("click", this.close);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.close);
  },
  methods: {
    openForMouse(event) {
      if (event.pointerType === MOUSE_POINTER) {
        this.open();
      }
    },
    closeForMouse(event) {
      if (event.pointerType === MOUSE_POINTER) {
        this.close();
      }
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
<style lang="scss">
.metric-info-tooltip__icon {
  margin-left: 6px;
  color: #8a8a8a;
  cursor: pointer;
}
.metric-info-tooltip {
  max-width: 280px;
  line-height: 1.4;
}
</style>
